export default __webpack_public_path__ + "static/media/logo.a4f839ad.png";